"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsMainSidebarMenu = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactProSidebar = require("react-pro-sidebar");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsMainSidebarMenu component represents a submenu in the main sidebar.
 * @param {Object} props - Component props.
 * @param {React.ReactNode} props.children - The content of the submenu. Should contain DmsMainSidebarMenu.Item components.
 * @param {string} props.title - The title or label for the submenu.
 * @param {React.ReactNode} props.icon - The icon to display alongside the submenu title.
 * @param {boolean} props.collapsed - Whether the sidebar is collapsed or expanded.
 * @returns {JSX.Element} DmsMainSidebarMenu component.
 * 
 * @example
 * <DmsMainSidebarMenu title={intl.get("User").d("User")} icon={<UsersIcon />} collapsed={collapsed}>
 *   <DmsMainSidebarMenu.Item>
 *     <DmsMainSidebarOption
 *       title={intl.get("Users").d("Users")}
 *       icon={<UserIcon />}
 *       route={ROUTES.User}
 *     />
 *     <DmsMainSidebarOption
 *       title={intl.get("UserLanguage").d("User Language")}
 *       icon={<LanguageIcon />}
 *       route={ROUTES.Language}
 *     />
 *     <DmsMainSidebarOption
 *       title={intl.get("Roles").d("Roles")}
 *       icon={<RoleIcon />}
 *       route={ROUTES.Role}
 *     />
 *   </DmsMainSidebarMenu.Item>
 * </DmsMainSidebarMenu>
 */
const DmsMainSidebarMenu = _ref => {
  let {
    children,
    title,
    icon,
    collapsed,
    active
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_material.Tooltip, {
    title: title,
    arrow: true,
    placement: "right"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactProSidebar.SubMenu, {
    label: collapsed ? null : /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "body2",
      style: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '160vw'
      }
    }, title),
    icon: icon
  }, children)));
};

/**
 * DmsMainSidebarMenu.Item component represents an item within a submenu.
 * @param {Object} props - Component props.
 * @param {React.ReactNode} props.children - The content of the submenu item.
 * @returns {JSX.Element} DmsMainSidebarMenu.Item component.
 */
exports.DmsMainSidebarMenu = DmsMainSidebarMenu;
DmsMainSidebarMenu.Item = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _react.default.Children.map(children, child => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, child)));
};